import React, { useEffect, useState } from 'react'
import CardSection from '../../../components/ui/card/CardSection';
import { useLocation } from 'react-router-dom';
import DatePicker from '../../../components/ui/inputs/datePicker/DatePicker';
import Buttons from '../../../components/ui/button/Buttons';
import DropDown from '../../../components/finalForms/ui/inputs/dropdown/DropDown';
import { useLazyGetAllUserQuery } from '../../../app/services/userAPI';
import formatDate from '../../../lib/formatDate';
import { getCardInfo } from '../../../lib/getCardInfo';
import { useLazyGetAllTimeSheetRecordsQuery } from '../../../app/services/timeSheetLogAPI';
import Accordion from '../../../components/accordion/Accordion';
import ToastService from '../../../services/toastService/ToastService';
import Label from '../../../components/finalForms/ui/label/Label';

const TimeSheetReport = () => {
  const [timesheetList, setTimesheetList] = useState(null);
  const [weekDate, setWeekDate] = useState(new Date());
  const [UserListData, setUserListData] = useState([]);
  const [UserIdData, setUserIdData] = useState(null);
  const [s_Date, setS_Date] = useState(new Date());
  const [e_Date, setE_Date] = useState(new Date());
  const [startDate] = useState();

  //api call

  const [getAllUser, {
    isSuccess: isUserListSuccess,
    data: UserList
  },] = useLazyGetAllUserQuery();

  const [getAllTimeSheetRecords, {
    isLoading: isAllRecordsLoading,
    isFetching: isAllRecordsFetching,
    isSuccess: isAllRecordsSuccess,
    data: timeSheetRecordsData,
  },] = useLazyGetAllTimeSheetRecordsQuery();


  useEffect(() => {
    if (isUserListSuccess && UserList) {
      const mappedUserList = UserList.map(user => ({
        value: user.userId,
        label: user.userName
      }));
      setUserListData(mappedUserList);
    }
  }, [isUserListSuccess, UserList]);

  useEffect(() => {
    if (!isAllRecordsFetching && isAllRecordsSuccess && timeSheetRecordsData) {
      setTimesheetList(timeSheetRecordsData);
    }
  }, [isAllRecordsFetching, isAllRecordsSuccess, timeSheetRecordsData]);

  const location = useLocation();
  const [initialStartDate] = useState(
    () => location.state?.startDate || new Date()
  );
  const [initialEndDate] = useState(
    () => location.state?.endDate || new Date()
  );

  const getStartOfWeek = (date) => {
    const day = date.getDay(); // 0 (Sunday) to 6 (Saturday)
    const diff = date.getDate() - day + (day === 0 ? -6 : 1); // Adjust when day is Sunday
    return new Date(date.setDate(diff));
  };

  const getEndOfWeek = (date) => {
    const day = date.getDay(); // 0 (Sunday) to 6 (Saturday)
    const diff = date.getDate() - day + (day === 0 ? -6 : 1) + 6; // Adjust and add 6 days to get Saturday
    return new Date(date.setDate(diff));
  };

  const filterPassedDate = (date) => {
    if (!weekDate) return true;
    const currentDate = new Date();
    const selectedDate = new Date(date);
    return selectedDate.getTime() <= currentDate.getTime();
  };

  const handleDateChange = (date) => {
    if (date) {
      setWeekDate(date);
      setS_Date(getStartOfWeek(new Date(date)));
      setE_Date(getEndOfWeek(new Date(date)));
    } else {
      setWeekDate(new Date());
    }
  };

  useEffect(() => {
    if (initialStartDate && initialEndDate) {
      setS_Date(getStartOfWeek(new Date(initialStartDate)));
      setE_Date(getEndOfWeek(new Date(initialEndDate)));
      setWeekDate(new Date(initialStartDate));
      getAllUser();
    } else {
      setS_Date(getStartOfWeek(new Date()));
      setE_Date(getEndOfWeek(new Date()));
      setWeekDate(new Date());
      getAllUser();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // const setWeekData = (date) => {
  //   setS_Date(getStartOfWeek(new Date(date)));
  //   setE_Date(getEndOfWeek(new Date(date)));
  // };

  // const isCurrentDateInWeek = (currentDate, weekStartDate) => {
  //   const startOfWeek = new Date(weekStartDate);
  //   const endOfWeek = new Date(startOfWeek);
  //   endOfWeek.setDate(startOfWeek.getDate() + 6);
  //   return currentDate >= startOfWeek && currentDate <= endOfWeek;
  // };

  // const currentDate = new Date();
  // const currentWeekStartDate = getStartOfWeek(new Date(weekDate));
 // const isTimesheetNavigationButtonDisabled = isCurrentDateInWeek(currentDate, currentWeekStartDate);

  // const handleNextWeekClick = () => {
  //   const currentWeekStartDate = getStartOfWeek(new Date(weekDate)); // Start of current week
  //   const nextWeekStartDate = new Date(
  //     currentWeekStartDate.setDate(currentWeekStartDate.getDate() + 7)
  //   ); // Add 7 days
  //   setWeekDate(nextWeekStartDate);
  // };

  // const handleTodayClick = () => {
  //   setWeekDate(new Date());
  // };

  // const handlePrevWeekClick = () => {
  //   const currentWeekStartDate = getStartOfWeek(new Date(weekDate)); // Start of current week
  //   const prevWeekStartDate = new Date(
  //     currentWeekStartDate.setDate(currentWeekStartDate.getDate() - 7)
  //   ); // Subtract 7 days
  //   if (weekDate.getTime() !== prevWeekStartDate.getTime()) {
  //     setWeekDate(prevWeekStartDate);
  //   }
  // };

  const handleUserChange = (e) => {
    setUserIdData(e);
  }
  const handleSearchClick = () => {
    if (UserIdData) {
      let starDate = weekDate?.toISOString();
      let request = {
        userId: UserIdData?.value,
        startDate: starDate,
      };
      getAllTimeSheetRecords(request);
    } else {
      ToastService.warning("Please select any Users")
    }
  }
  // Custom Header Content
  const headerContentWrapper = () => {
    return (
      <>
        <div className="d-flex row align-items-center w-100 report-user-lable">
          <div className="d-flex gap-3 align-items-center col-10 px-0 ">
          <Label  labelName="Select User" isRequired={true} />
            <DropDown
              placeholder="Select User"
              options={UserListData}
              value={UserIdData}
              onChange={(e) => { handleUserChange(e) }}
            />
             <Label className="timesheet-report-userwise" labelName="Select Date" isRequired={true} />
            <DatePicker
              isDisable={false}
              selected={new Date(weekDate)}
              onChange={handleDateChange}
              placeholder={"select date"}
              onBlur={() => { }}
              datePickerConfig={{ filteredDate: filterPassedDate, format: "dd/MM/yyyy", }}
            />
          </div>
          {/* <Buttons
              buttonText="Prev"
              textWithIcon={true}
              fontIcon={true}
              iconName={`fluent:arrow-previous-16-filled`}
              onClick={handlePrevWeekClick}
              buttonTypeClassName="theme-btn"
            />
            <Buttons
              buttonText="Current"
              textWithIcon={true}
              fontIcon={true}
              iconName={`ic:outline-today`}
              onClick={handleTodayClick}
              buttonTypeClassName="theme-btn"
            />
          <Buttons
            buttonText="Next"
            textWithIcon={true}
            fontIcon={true}
            iconName={`fluent:arrow-next-16-filled`}
            onClick={handleNextWeekClick}
            buttonTypeClassName="theme-btn"
           isDisable={isTimesheetNavigationButtonDisabled}
          /> */}
        </div>
         <Buttons
          buttonTypeClassName="btn theme-btn"
          textWithIcon={true}
          fontIcon={true}
          iconName={'material-symbols:search-rounded'}
          buttonText="Search"
          isDisable={!UserIdData}
          //  isDisable={buttonDisable}
          onClick={() => handleSearchClick()}
        />
      </>
    );
  };

  const cardData = [
    {
      key: "Timesheet Week",
      value: formatDate(s_Date, "DD MMM, YYYY") + " - " + formatDate(e_Date, "DD MMM, YYYY"),
    },
  ];

  return (
    <>
      <div className="card-section-info mt-2">
        {cardData ? getCardInfo(cardData) : null}
      </div>
      <div className="center-top-space">
        <CardSection
          isContentLoading={isAllRecordsLoading}
          customHeader={true}
          headerContentWrapper={headerContentWrapper()}
          cardTitle={`Time Sheet Report - Userwise`}
        >
          <div className="timesheet-accordion">
            <Accordion
              startDate={startDate}
              isLoading={isAllRecordsLoading}
              data={timesheetList}
               descriptionTooltipOnlyOnOverflow={true}
            />
          </div>
        </CardSection>
      </div>
    </>
  )
}

export default TimeSheetReport;
